import type { VideoV1, VideoMarket, BookV1 } from '@ilteducation/content-registry-types';
import type { RelatedContentItem } from '@ilteducation/similar-content';

export declare type BreadcrumbsStep = {
  name: string;
  path: string;
};

export declare type AudioResource = {
  url: string;
  key: string;
  id: string;
  lang: string;
};

export declare type Snack = {
  message: string;
  color: string;
  show: boolean;
};

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[]
  ? ElementType
  : never;

// should probably be a part of @ilteducation/content-registry-types
export interface ITranslated {
  market: 'global' | VideoMarket;
  languageCode: string;
}

export type BookLink = ITranslated & {
  value: {
    bookId: string;
    url?: string;
  }[];
};

export declare type Video = Omit<
  VideoV1,
  | 'title'
  | 'description'
  | 'summary'
  | 'slug'
  | 'introfilmsIds'
  | 'introfilmsUids'
  | 'previewImage'
  | 'narrations'
  | 'subtitles'
  | 'bookLinks'
> & {
  title: string;
  description: string;
  summary: string;
  slug: string;
  resourceId: string; // `${videoId}-${realm}` format used in exercise model
  introfilmsIds: NonNullable<VideoV1['introfilmsIds'][VideoMarket]>;
  introfilmsUids: NonNullable<VideoV1['introfilmsUids'][VideoMarket]>;
  previewImage?: string;
  thumbnail?: string;
  narrations: (ITranslated & {
    value: NonNullable<ArrayElement<VideoV1['narrations']>['value']>;
  })[];
  subtitles: (ArrayElement<VideoV1['subtitles']> & {
    value: NonNullable<ArrayElement<VideoV1['subtitles']>['value']>;
  })[];
  bookLinks: { [categoryId: string]: BookLink[] };
};

export declare type SubjectVideo = Video & { subjectId: string };

export type BookWithRelatedContents = BookV1 & { items?: RelatedContentItem[] };

export interface FilterConfig {
  name: string;
  cols: number;
  sm: number;
  md: number;
  items: any[];
  placeholder: string;
  ariaLabel?: string;
  itemTitle: string | ((item: any) => string);
  itemValue: string;
  extraProps?: Record<string, any>;
}

export enum Tabs {
  keywords = 0,
  quiz,
  exercises,
  subtitles,
  articles,
  immerse,
  curriculum,
  materials,
  videosInArea,
}

export type TabInfo = {
  title: string;
  icon: string;
  enabled: boolean;
  tooltip: boolean;
  tooltipText?: string;
  value: Tabs;
};
